import React from "react";
import { AppBar, Box, Container, Toolbar } from "@mui/material";

import { HeaderProfile } from "../HeaderProfile";
import { HeaderNavigation } from "../HeaderNavigation";
import { HeaderLogotype } from "../HeaderLogotype";
import { useLoginStore } from "../../../LoginModule/store";

export const Header = () => {
  const isAuth = useLoginStore((state) => !!state.accessToken);

  return (
    <Box component="header" data-testid="header">
      <AppBar position="static">
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <HeaderLogotype to={isAuth ? "/" : "/login"} />
            {isAuth && (
              <React.Fragment>
                <HeaderNavigation />
                <HeaderProfile />
              </React.Fragment>
            )}
          </Toolbar>
        </Container>
      </AppBar>
    </Box>
  );
};
